(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[480],{

/***/ 5920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppContentContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_app_content_app_title_AppTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8990);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function AppContentContainer(param) {
    var title = param.title, routerPaths = param.routerPaths, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full", !routerPaths.includes("selling-hours") && "hidden", "md:block"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_content_app_title_AppTitle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    Title: title,
                    routerPath: routerPaths
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 8990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_title_AppTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./src/components/app-content/app-title/AppTitle.module.scss
var AppTitle_module = __webpack_require__(8351);
var AppTitle_module_default = /*#__PURE__*/__webpack_require__.n(AppTitle_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/images/print.svg
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__a")
  }, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.526 0c1.05 0 1.902.864 1.902 1.93v3.519a.53.53 0 0 1 0 .133h1.203c.9 0 1.76.365 2.393 1.012.633.648.984 1.525.976 2.436v3.992c-.006.978-.786 1.77-1.75 1.775h-2.802v3.766A1.436 1.436 0 0 1 16.022 20H5.978c-.784 0-1.42-.642-1.426-1.437v-3.807H1.75C.786 14.751.006 13.96 0 12.981V8.989c.006-1.883 1.512-3.407 3.368-3.407h1.153V1.93C4.521.864 5.373 0 6.423 0h9.103Zm.152 12.006H6.322v6.157h9.356v-6.157Zm2.953-4.648H3.368a1.61 1.61 0 0 0-1.598 1.61v3.992h2.782v-2.79h12.896v2.79l2.782-.02V8.969a1.61 1.61 0 0 0-1.599-1.611Zm-.12.841c.373 0 .677.308.677.688 0 .38-.304.687-.678.687a.683.683 0 0 1-.678-.687c0-.38.304-.688.678-.688Zm-2.954-6.403H6.453a.132.132 0 0 0-.131.133v3.52c0 .074.059.133.131.133h9.104c.072 0 .131-.06.131-.133v-3.52a.132.132 0 0 0-.131-.133Z"
  }))), /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__b")
  }, _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M24 0v24H0V0h24Z"
  })))), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__a)"),
    transform: "translate(1 2)"
  }, _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v20H0V0z"
  })), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__b)"),
    transform: "translate(-1 -2)"
  }, _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M1 2h22v20H1V2z"
  })))));
};
/* harmony default export */ var print = (SvgPrint);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5440);
;// CONCATENATED MODULE: ./src/components/app-content/app-title/AppTitle.tsx





var AppTitle = function(param) {
    var Title = param.Title, routerPath = param.routerPath;
    var t = (0,esm/* useTranslation */.$G)().t;
    var betTypeStyle = (AppTitle_module_default())[(0,lodash.toLower)(routerPath[1])] || "";
    var infoStyle = (0,lodash.toLower)(routerPath[0]) === "info" ? (AppTitle_module_default())[(0,lodash.toLower)(routerPath[0])] : "";
    var showPrint = [
        "selling-hours"
    ].includes(routerPath[routerPath.length - 1]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AppTitle_module_default()).title, " ").concat(betTypeStyle, " ").concat(infoStyle, " ").concat((AppTitle_module_default())[routerPath[routerPath.length - 1]]),
        children: [
            Title,
            showPrint && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (AppTitle_module_default()).print,
                onClick: function() {
                    try {
                        window.print();
                    } catch (e) {
                        console.log(e);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(print, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("Print")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var app_title_AppTitle = (AppTitle);


/***/ }),

/***/ 1862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_google_map_AppGoogleMap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(7054);
// EXTERNAL MODULE: ./src/common/pathConvert.ts + 1 modules
var pathConvert = __webpack_require__(7507);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/hooks/useGoogleMapScript.ts



var preLocale;
function useGoogleMapScript() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if ((window === null || window === void 0 ? void 0 : window.google) && preLocale !== router.locale) {
            //fix error:"You have included the Google Maps JavaScript API multiple times on this page"
            (window).google = {};
        }
        preLocale = router.locale;
    }, [
        router.locale
    ]);
    return (0,esm/* useLoadScript */.Db)({
        language: router.locale,
        googleMapsApiKey: "AIzaSyD7P4ugzi2-sXAaaNpdhq3mN2cUFrzib0k"
    });
}

;// CONCATENATED MODULE: ./src/components/app-google-map/AppGoogleMap.tsx





var _defaultMarkerIcon, _selectedMarkerIcon;
function AppGoogleMap(param) {
    var addressList = param.addressList, showAddressInfo = param.showAddressInfo, selectedIndex = param.selectedIndex, onSelectedChange = param.onSelectedChange;
    var isLoaded = useGoogleMapScript().isLoaded;
    var ref = (0,react.useState)(), map = ref[0], setMap = ref[1];
    var clusterRef = (0,react.useRef)();
    var defaultMarkerIcon = (0,react.useRef)();
    var selectedMarkerIcon = (0,react.useRef)();
    var ref1 = (0,react.useState)(), selectedAddress = ref1[0], setSelectedAddress = ref1[1];
    (0,react.useEffect)(function() {
        if (map && addressList && addressList.length) {
            var bounds = new google.maps.LatLngBounds();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = addressList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var branch = _step.value;
                    bounds.extend(branch);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (map) {
                map.fitBounds(bounds);
            }
        }
        setSelectedAddress(null);
    }, [
        map,
        addressList
    ]);
    (0,react.useEffect)(function() {
        if (clusterRef.current) {
            var _current;
            (_current = (_defaultMarkerIcon = defaultMarkerIcon).current) !== null && _current !== void 0 ? _current : _defaultMarkerIcon.current = {
                url: (0,pathConvert/* withBasePath */.w)("/images/spotlight-poi3.png"),
                scaledSize: new google.maps.Size(26, 26 * 1.423)
            };
            var _current1;
            (_current1 = (_selectedMarkerIcon = selectedMarkerIcon).current) !== null && _current1 !== void 0 ? _current1 : _selectedMarkerIcon.current = {
                url: (0,pathConvert/* withBasePath */.w)("/images/spotlight-poi3.png"),
                scaledSize: new google.maps.Size(32, 32 * 1.423)
            };
            clusterRef.current.markers.forEach(function(marker, index) {
                if (selectedIndex === index) {
                    marker.setIcon(selectedMarkerIcon.current);
                } else {
                    marker.setIcon(defaultMarkerIcon.current);
                }
            });
        }
    }, [
        selectedIndex
    ]);
    var onLoad = (0,react.useCallback)(function(map) {
        setMap(map);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full aspect-video ",
        children: isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* GoogleMap */.b6, {
            mapContainerClassName: "w-full h-full",
            onLoad: onLoad,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MarkerClusterer */.XL, {
                    minimumClusterSize: Number.MAX_SAFE_INTEGER,
                    onLoad: function(cluster) {
                        clusterRef.current = cluster;
                    },
                    children: function(cluster) {
                        var markers = addressList === null || addressList === void 0 ? void 0 : addressList.map(function(b, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MarkerF */.jC, {
                                position: b,
                                clusterer: cluster,
                                onLoad: function(marker) {
                                    showAddressInfo && marker.addListener("click", function() {
                                        var ref;
                                        (ref = marker.getMap()) === null || ref === void 0 ? void 0 : ref.setOptions({
                                            center: b,
                                            zoom: 16
                                        });
                                        setSelectedAddress({
                                            address: b,
                                            marker: marker
                                        });
                                    });
                                },
                                onMouseOver: function() {
                                    onSelectedChange && onSelectedChange(index);
                                },
                                onMouseOut: function() {
                                    onSelectedChange && onSelectedChange();
                                }
                            }, index);
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: markers
                        });
                    }
                }),
                selectedAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InfoWindowF */.kp, {
                    position: selectedAddress.address,
                    anchor: selectedAddress.marker,
                    onCloseClick: function() {
                        setSelectedAddress(null);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    fontSize: "14px",
                                    color: "#666",
                                    fontWeight: "bold"
                                },
                                children: selectedAddress.address.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "270px",
                                    color: "#666"
                                },
                                children: selectedAddress.address.address
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mt-5 ",
                                src: selectedAddress.address.image,
                                alt: ""
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}
/* harmony default export */ var app_google_map_AppGoogleMap = (/*#__PURE__*/(0,react.memo)(AppGoogleMap));


/***/ }),

/***/ 8480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AppLuckyOCB; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_app_content_container_AppContentContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5920);
/* harmony import */ var _components_app_google_map_AppGoogleMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1862);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5440);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _AppLuckyOCB_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1935);
/* harmony import */ var _AppLuckyOCB_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AppLuckyOCB_module_scss__WEBPACK_IMPORTED_MODULE_6__);







function AppLuckyOCB(param) {
    var Content = param.pageData.Content, routerPath = param.routerPath;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)(), 1), t = ref5[0];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), selectedBranchIndex = ref6[0], setSelectedBranchIndex = ref6[1];
    var branches = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var ref;
        return (ref = Content === null || Content === void 0 ? void 0 : Content.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            var ref;
            return ((ref = item.enabled) === null || ref === void 0 ? void 0 : ref.value) === "1";
        }).map(function(item) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
            return {
                key: item.key,
                name: (ref = item.branchId) === null || ref === void 0 ? void 0 : (ref1 = ref.targetItem) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.branchBasicInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.targetItem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.branchName) === null || ref4 === void 0 ? void 0 : ref4.value,
                address: (ref5 = item.branchId) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.targetItem) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.branchBasicInfo) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.targetItem) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.branchAddress) === null || ref9 === void 0 ? void 0 : ref9.value,
                lat: parseFloat((ref10 = item.branchId) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.targetItem) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.latitude) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.value) === null || ref13 === void 0 ? void 0 : ref13.trim()),
                lng: parseFloat((ref14 = item.branchId) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.targetItem) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.longitude) === null || ref16 === void 0 ? void 0 : ref16.value.trim()),
                records: (ref18 = (ref17 = item.yearWinningRecord) === null || ref17 === void 0 ? void 0 : ref17.value) === null || ref18 === void 0 ? void 0 : ref18.split(",").map(function(r) {
                    return parseInt(r.trim());
                }),
                enable: ((ref19 = item.enabled) === null || ref19 === void 0 ? void 0 : ref19.value) === "1"
            };
        });
    }, [
        Content === null || Content === void 0 ? void 0 : Content.data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_content_container_AppContentContainer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        routerPaths: routerPath,
        title: Content === null || Content === void 0 ? void 0 : (ref = Content.pageTitle) === null || ref === void 0 ? void 0 : ref.value,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "p-3 md:p-6 flex flex-col items-stretch",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "m-0",
                    dangerouslySetInnerHTML: {
                        __html: Content === null || Content === void 0 ? void 0 : (ref1 = Content.header) === null || ref1 === void 0 ? void 0 : ref1.value
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full py-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_google_map_AppGoogleMap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        selectedIndex: selectedBranchIndex,
                        addressList: branches || [],
                        onSelectedChange: function(index) {
                            setSelectedBranchIndex(index);
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "py-3 overflow-x-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            dangerouslySetInnerHTML: {
                                __html: Content === null || Content === void 0 ? void 0 : (ref2 = Content.tableTitle) === null || ref2 === void 0 ? void 0 : ref2.value
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "overflow-x-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
                                className: (_AppLuckyOCB_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["branch-table"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "min-w-[50px] md:min-w-[102px]",
                                                    children: t("LuckOCB.BranchName")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "min-w-[120px]",
                                                    children: t("LuckOCB.Address")
                                                }),
                                                Content === null || Content === void 0 ? void 0 : (ref3 = Content.yearColumns) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.split(",").map(function(year, idx) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: year
                                                    }, year + idx);
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: t("LuckOCB.Total")
                                                })
                                            ]
                                        }),
                                        branches && branches.map(function(b, index) {
                                            var ref;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                className: selectedBranchIndex === index ? (_AppLuckyOCB_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["selected-branch"]) : "",
                                                onMouseOver: function() {
                                                    setSelectedBranchIndex(index);
                                                },
                                                onMouseOut: function() {
                                                    if (selectedBranchIndex === index) {
                                                        setSelectedBranchIndex(undefined);
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: index + 1
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: b.name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: b.address
                                                    }),
                                                    b.records && b.records.map(function(r, rIndex) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                            align: "center",
                                                            children: r || "-"
                                                        }, rIndex);
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        align: "center",
                                                        children: (ref = b.records) === null || ref === void 0 ? void 0 : ref.reduce(function(r1, r2) {
                                                            return r1 + r2;
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pt-3",
                            dangerouslySetInnerHTML: {
                                __html: Content === null || Content === void 0 ? void 0 : Content.tableFootnote.value
                            }
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 8351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"AppTitle_title__v29lb","racing":"AppTitle_racing__2sxjA","football":"AppTitle_football__peh_Y","marksix":"AppTitle_marksix__Cjj1F","print":"AppTitle_print__ogwEH","match-info":"AppTitle_match-info__C7I7R","info":"AppTitle_info__SdhGn"};

/***/ }),

/***/ 1935:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"branch-table":"AppLuckyOCB_branch-table__g6OQl","border-right":"AppLuckyOCB_border-right__EAr1R","selected-branch":"AppLuckyOCB_selected-branch__5HHxC"};

/***/ })

}]);